import CustomCursor from "custom-cursor.js"

export {}

const cursorElement = document.querySelector(".c-cursor")
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

if (cursorElement && !isSafari) {
  const customCursor = new CustomCursor(cursorElement, {
    hideTrueCursor: false,
    focusElements: [
      {
        elements: `.--js-cursor-focus-elements`,
        focusClass: "--focused",
        mouseenter: () => {
          customCursor.enable()
          customCursor.hideTrueCursor()
        },
        mouseleave: () => {
          customCursor.disable()
          customCursor.unhideTrueCursor()
        },
      },
    ],
  }).initialize()

  document.addEventListener("cursorInit", () => {
    customCursor.initialize()
  })
}
